import { render, staticRenderFns } from "./ChangesModal.vue?vue&type=template&id=6c94c26a&scoped=true&"
import script from "./ChangesModal.vue?vue&type=script&lang=js&"
export * from "./ChangesModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangesModal.vue?vue&type=style&index=0&id=6c94c26a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c94c26a",
  null
  
)

export default component.exports